import { type SVGProps } from "react";

export default function ArrowLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-fluid-6"
      {...props}
    >
      <path d="M11 5l-7 7 7 7" />
      <path d="M4 12h16" />
    </svg>
  );
}
